import { IStyle } from '@fluentui/react';
import { IH2OTheme } from '@h2oai/ui-kit';

export interface IFeatureStyles {
  root?: IStyle;
}

export interface IFeatureClassNames {
  root: string;
}

export const featureStylesDefault = (_theme: IH2OTheme): Partial<IFeatureStyles> => ({
  root: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    minHeight: 0,
  },
});
